import utils from '../utils/utils';

// כל הפעולות מול השרת. פעולה חדשה צריכה להופיע גם ב-PUBLIC_ACTIONS ב-server/src/routes/ver1Router.ts
export const API = {
  // sort: 'relevance' | 'diff'
  searchProducts: (q, sort) => utils.requestData('SearchProducts', { q, sort }),
  // כל שמות המוצרים והחברות, להשלמה אוטומטית (נטען פעם אחת, ר' SearchTab.jsx)
  getSearchSuggestions: () => utils.requestData('GetSearchSuggestions', {}),
};
